<template>
  <section>
    <span v-show="item.edited == '1'" >
      <p class="mt-2 editForm">        
         {{ item.title }}: {{item.text}} <i class="fal fa-times-circle" @click="removeEdit"  v-b-tooltip.hover :title="$t('TEMPLATE.FORM.REMOVE')" />
      </p>
    </span>
    <b-card no-body v-show="item.edited == '0'" class="mt-2">
      <b-card-body>
        <b-row>
          <b-col sm="3" class="text-right">
            <label>{{ item.title }}:</label>
          </b-col>
          <b-col sm="9">
            <b-input v-model="item.text" v-on:keyup.enter="saveForm"></b-input>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer>
        <b-button class="float-right mt-2 btn-fill" @click="saveForm">Save</b-button>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
export default {
  props: ["value","templateId"],
  data() {
    return {
      item: this.value,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    saveForm: function() {
      let self = this;
      this.$http.post(process.env.VUE_APP_BACKEND + "/template/document/answer/update", {
        templateId: this.templateId,
        answers:  [{
          key: this.item.id,
          value: this.item.text
        }]
      })
      .then(function() {
        self.item.edited = "1";
        self.$emit("input",self.item);
      })
      .catch(function() {
        self.item.edited = "0";
        self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
      });        
    },
    removeEdit: function() {
      this.item.edited = "0";
    }
  },
  mounted: function() {
  }
};
</script>
<style>
</style>